import Vue from "vue";
import App from "./App.vue";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "./assets/style.scss";
import Vuex from "vuex";
import store from './store'
import router from './router'
import mixin from './mixin'
import VueSweetAlert2 from 'vue-sweetalert2'
import "@mdi/font/css/materialdesignicons.min.css"
import { firestorePlugin } from 'vuefire'

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Buefy);
Vue.mixin(mixin);
Vue.use(firestorePlugin);

const swalOptions = {
    confirmButtonColor: '#8bc34a',
    cancelButtonColor: '#607d8b',
    confirmButtonText: 'ຕົກລົງ',
    cancelButtonText: 'ຍົກເລີກ',
    allowOutsideClick: false,
    allowEscapeKey: false,
};
Vue.use(VueSweetAlert2, swalOptions);

new Vue({
    store,
    router,
    render: (h) => h(App),
}).$mount("#app");
